/*!

=========================================================
* Argon Design System React - v1.1.2
=========================================================

* Product Page: https://www.creative-tim.com/product/argon-design-system-react
* Copyright 2023 Creative Tim (https://www.creative-tim.com)
* Licensed under MIT (https://github.com/creativetimofficial/argon-design-system-react/blob/master/LICENSE.md)

* Coded by Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/
import React, { useState, useEffect, useRef } from "react";
import {
    Button,
    Card,
    CardHeader,
    CardBody,
    FormGroup,
    Form,
    Input,
    InputGroupAddon,
    InputGroupText,
    InputGroup,
    Container,
    Row,
    Col,
} from "reactstrap";
import DemoNavbar from "components/Navbars/DemoNavbar.js";
import MainFooter from "components/Footers/MainFooter.js";
import { AddPracticeProblemRequest, GetAllLessons } from "../../services/AdminServices";

const AddPracticeProblem = () => {

    const [state, setState] = useState({
        courseID: "",
        lessonID: "",
        problemNumber: "",
    });

    const [lessonList, setLessonList] = useState(null);

    const mainRef = useRef(null);

    useEffect(() => {
        document.documentElement.scrollTop = 0;
        document.scrollingElement.scrollTop = 0;
        mainRef.current.scrollTop = 0;
        handleGetAllLessons();

    }, []);

    const handleChange = (event) => {
        setState({ ...state, [event.target.name]: event.target.value });
    };

    const handleGetAllLessons = async () => {
        const lessonListData = await GetAllLessons();
        setLessonList(lessonListData);
    }

    const handleSubmit = async (event) => {
        event.preventDefault();
        const { courseID, lessonID, problemNumber } = state;

        try {
            await AddPracticeProblemRequest(courseID, lessonID, problemNumber);
            setState({
                ...state,
                message: "User Added Lesson successfully!",
                error: null,
            });
        } catch (error) {
            setState({ ...state, error: error.message, message: null });
        }
    };

    return (
        <>
            <DemoNavbar />
            <main ref={mainRef}>
                <section className="bordersection section-shaped section-lg">
                    <div className="shape shape-style-1 bg-gradient-default">
                        <span />
                        <span />
                        <span />
                        <span />
                        <span />
                        <span />
                        <span />
                        <span />
                    </div>
                    <Container className="pt-lg-7">
                        <Row className="justify-content-center">
                            {/* Progressive sizing — see AddLesson.js for rationale. */}
                            <Col xs="12" md="10" lg="6" xl="5">
                                <Card className="bg-secondary shadow border-0">
                                    <CardHeader className="bg-white pb-5">
                                        <div className="text-muted text-center mb-3">
                                            <small>Add Practice Problem to DB</small>
                                        </div>
                                    </CardHeader>
                                    <CardBody className="px-lg-5 py-lg-5">
                                        <Form onSubmit={handleSubmit} role="form">
                                            <FormGroup>
                                                <label className="required">Courses</label>
                                                <InputGroup className="input-group-alternative mb-3">
                                                    <Input
                                                        type="select"
                                                        name="courseID"
                                                        onChange={handleChange}
                                                        required
                                                    >
                                                        <option value="" disabled selected>
                                                            Select a Course
                                                        </option>
                                                        <option value="JA01">JA01</option>
                                                        <option value="JA02">JA02</option>
                                                        <option value="JA03">Course 3</option>
                                                        <option value="JS01">JS01</option>
                                                        {/* Add more options as needed */}
                                                    </Input>
                                                </InputGroup>
                                            </FormGroup>
                                            <FormGroup>
                                                <label className="required">Lessons</label>
                                                <InputGroup className="input-group-alternative mb-3">
                                                    <Input
                                                        type="select"
                                                        name="lessonID"
                                                        onChange={handleChange}
                                                        required
                                                    >
                                                        <option value="" disabled selected>
                                                            Select a Lesson
                                                        </option>
                                                        {lessonList?.map((lessonItem, index) => (
                                                            <div key={index}>
                                                                <option value={lessonItem.id}>{lessonItem.id}</option>
                                                            </div>

                                                        ))}
                                                    </Input>
                                                </InputGroup>
                                            </FormGroup>
                                            <FormGroup>
                                                <label className="required">Problem Number</label>
                                                <InputGroup className="input-group-alternative mb-3">

                                                    <Input
                                                        type="select"
                                                        name="problemNumber"
                                                        onChange={handleChange}
                                                        required

                                                    >


                                                        <option value="" disabled selected>
                                                            Select Problem Number
                                                        </option>
                                                        <option value="P1">1</option>
                                                        <option value="P2">2</option>
                                                        <option value="P3">3</option>
                                                        <option value="P4">4</option>
                                                        <option value="P5">5</option>
                                                        <option value="P6">6</option>
                                                        <option value="P7">7</option>
                                                        <option value="P8">8</option>
                                                        <option value="P9">9</option>
                                                        <option value="P10">10</option>
                                                        <option value="P11">11</option>
                                                        <option value="P12">12</option>
                                                        <option value="P13">13</option>
                                                        <option value="P14">14</option>
                                                        <option value="P15">15</option>
                                                        <option value="P16">16</option>
                                                        <option value="P17">17</option>
                                                        <option value="P18">18</option>
                                                        <option value="P19">19</option>
                                                        <option value="P20">20</option>

                                                        {/* Add more options as needed */}
                                                    </Input>

                                                </InputGroup>
                                            </FormGroup>

                                            <div className="text-center">
                                                <Button className="mt-4" color="primary" type="submit">
                                                    Add Lesson
                                                </Button>
                                            </div>
                                        </Form>
                                    </CardBody>
                                </Card>
                            </Col>
                        </Row>
                    </Container>
                </section>
            </main>
            <MainFooter />
        </>
    );
};

export default AddPracticeProblem;
